import {
  Table,
  TableCell,
  TableRow,
  TableHeader,
  Paragraph,
  TextRun,
  WidthType,
  AlignmentType,
  TableWidth,
  VerticalAlign,
} from "docx";

// ... imports and function start remain unchanged

export function ModelWorldVleresimGjinor2(data) {
  const docSections = [];

  const headerStyle = (text, bgColor = "FFFFFF", options = {}) =>
    new TableCell({
      shading: {
        fill: bgColor,
      },
      children: [
        new Paragraph({
          children: [new TextRun({ text, italics: true })],
          alignment: AlignmentType.CENTER,
        }),
      ],
      margins: {
        top: 200, // në twips (1/20 i pikës, 100 = 5pt)
        bottom: 200,
        left: 40, // 200 = 10pt
        right: 40,
      },
    });

  const headerSpanStyle = (text, bgColor = "FFFFFF") =>
    new TableCell({
      shading: {
        fill: bgColor,
      },
      children: [
        new Paragraph({
          children: [new TextRun({ text, bold: true })],
          alignment: AlignmentType.CENTER,
        }),
      ],
      verticalAlign: VerticalAlign.CENTER,
      rowSpan: 2,
      margins: {
        top: 120, // në twips (1/20 i pikës, 100 = 5pt)
        bottom: 120,
        left: 40, // 200 = 10pt
        right: 40,
      },
    });

  const cell = (text, bgColor = null, options = {}) =>
    new TableCell({
      shading: bgColor ? { fill: bgColor } : undefined,
      children: [
        new Paragraph({
          children: [new TextRun(text)],
          alignment: AlignmentType.CENTER,
        }),
      ],
      margins: {
        top: 200, // në twips (1/20 i pikës, 100 = 5pt)
        bottom: 200,
        left: 40, // 200 = 10pt
        right: 40,
      },
    });

  const tableRows = [];

  // Header Row 1
  tableRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [
            new Paragraph({
              children: [new TextRun({ text: "Moderatorët", bold: true })],
              alignment: AlignmentType.CENTER,
            }),
          ],
          columnSpan: 2,
        }),
        headerSpanStyle("Televizioni"),
        new TableCell({
          children: [
            new Paragraph({
              children: [new TextRun({ text: "Të ftuarit", bold: true })],
              alignment: AlignmentType.CENTER,
            }),
          ],
          columnSpan: 2,
        }),
      ],
    })
  );

  // Header Row 2 (4 cells only, Televizioni is rowSpan from above)
  tableRows.push(
    new TableRow({
      children: [
        headerStyle("Meshkuj", "bbdefb"),
        headerStyle("Femra", "f8bbd0"),
        headerStyle("Meshkuj", "bbdefb"),
        headerStyle("Femra", "f8bbd0"),
      ],
    })
  );

  // Data Rows
  data.forEach((row) => {
    const modMeshkuj = parseInt(row["Nr. moderatorëve meshkuj"] || 0);
    const modFemra = parseInt(row["Nr. moderatorëve Femra"] || 0);
    const ftuarMeshkuj = parseInt(row["Nr. të ftuarve Meshkuj"] || 0);
    const ftuarFemra = parseInt(row["Nr. të ftuarve Femra"] || 0);

    const totalModeratore = modMeshkuj + modFemra;
    const totalFtuar = ftuarMeshkuj + ftuarFemra;

    const percModMeshkuj =
      totalModeratore > 0
        ? ((modMeshkuj / totalModeratore) * 100).toFixed(1)
        : "0.0";
    const percModFemra =
      totalModeratore > 0
        ? ((modFemra / totalModeratore) * 100).toFixed(1)
        : "0.0";

    const percFtuarMeshkuj =
      totalFtuar > 0 ? ((ftuarMeshkuj / totalFtuar) * 100).toFixed(1) : "0.0";
    const percFtuarFemra =
      totalFtuar > 0 ? ((ftuarFemra / totalFtuar) * 100).toFixed(1) : "0.0";

    tableRows.push(
      new TableRow({
        children: [
          cell(`${percModMeshkuj}%`, "bbdefb"),
          cell(`${percModFemra}%`, "f8bbd0"),
          cell(row["Nr. Subjekti"]), // This is the "Televizioni"
          cell(`${percFtuarMeshkuj}%`, "bbdefb"),
          cell(`${percFtuarFemra}%`, "f8bbd0"),
        ],
      })
    );
  });

  const table = new Table({
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: tableRows,
  });

  docSections.push(table);
  return docSections;
}
